import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { fonts } from '../../styles/theme';

import { DateTimePicker } from './DateTimePicker';
import { Button } from '../buttons';

const CustomRangeDivider = styled('span')`
  font-size: ${fonts.sans.size.small};
  margin: 0 8px;
`;

const CustomRangeButton = styled(Button)`
  div[class*='DateTimeWrapper'] + & {
    margin-left: 10px;
  }
  & + i {
    margin-left: 10px;
  }
`;

export const RangeDisplay = styled('div')`
  font-size: ${fonts.sans.size.small};
  margin: 3px 0;
  span {
    font-weight: ${fonts.sans.weight.bold};
  }
`;

export const CustomRangeSelector = (props) => {
  const { onRangeSelected, defaultFromDate, defaultToDate } = props;

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  useEffect(() => {
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  }, [defaultFromDate, defaultToDate]);

  return (
    <>
      <DateTimePicker
        onChange={(selection) => {
          setFromDate(selection);
        }}
        dateFormat="MMMM d, yyyy"
        selected={fromDate}
        selectsStart
        startDate={fromDate}
        endDate={toDate}
        maxDate={toDate}
        range
      />
      <CustomRangeDivider>to</CustomRangeDivider>
      <DateTimePicker
        onChange={(selection) => {
          setToDate(selection);
        }}
        dateFormat="MMMM d, yyyy"
        selected={toDate}
        selectsEnd
        startDate={fromDate}
        endDate={toDate}
        minDate={fromDate}
        range
      />
      <CustomRangeButton variant="primary" onClick={() => onRangeSelected(fromDate, toDate)}>
        View
      </CustomRangeButton>
    </>
  );
};

CustomRangeSelector.propTypes = {
  onRangeSelected: PropTypes.func.isRequired,
  defaultFromDate: PropTypes.instanceOf(Date),
  defaultToDate: PropTypes.instanceOf(Date),
};

CustomRangeSelector.defaultProps = {
  defaultFromDate: new Date(),
  defaultToDate: new Date(),
};
